export default {
  translation: {
    'Configuration obtained successfully, initiating offer...': '設定の取得に成功しました。オファーを開始します...',
    'Remote offer retrieved successfully...': 'リモートオファーの取得に成功しました...',
    'Ready to send ICE...': 'ICEの送信準備完了...',
    'Exchange ICE successfully...': 'ICE交換成功、接続を確立中...',
    'Configuring ICE, waiting for response...': 'ICEを設定中、応答を待っています...',
    'Connected': '接続成功',
    'Connecting...': '接続中...',
    'Disconnecting...': '切断中...',
    'Toggle Performance': 'パフォーマンス情報の表示/非表示',
    'Toggle Virtual Gamepad': '仮想ゲームパッドの表示/非表示',
    'Disconnect': '切断',
    'Key Maping': 'キーマッピング',
    'Please press the button on the controller, which will be mapped to:': 'コントローラーのボタンを押してください。このボタンは以下にマッピングされます:',
    'After successful mapping, this pop-up will automatically close': 'マッピングが成功すると、このポップアップは自動的に閉じます',
    'Cancel': 'キャンセル',
    'Save': '保存',
    'Saving...': '保存中...',
    'Saved': '保存成功',
    'Reset': 'デフォルトに戻す',
    'Please press the button on the gamepad; this button will be mapped to:': 'ゲームパッドのボタンを押してください。このボタンは以下にマッピングされます:',
    'After successful mapping, this popup will automatically close.': 'マッピングが成功すると、このポップアップは自動的に閉じます',
    'Warning': '警告',
    'The terminal seems to have been without a screen for a long time. Please try reconnecting.': '端末が長時間画面を表示していないようです。OKボタンをクリックしてストリーミング資格情報を更新し、再接続してみてください。',
    'NAT traversal failed. If you were attempting remote streaming and it was successful before, please click the refresh button below to refresh the streaming credentials and try again.': 'NATトラバーサルに失敗しました。以前リモートストリーミングに成功したことがある場合は、下の更新ボタンをクリックしてストリーミング資格情報を更新し、再試行してください。何度か試しても接続できない場合は、しばらく待ってからもう一度お試しください。',
    'Keep waiting': '待ち続ける',
    'Exit': '終了',
    'Refresh': '更新',
    'Resolution': '解像度',
    'Round Trip Time': '遅延',
  }
}